import React from "react";
import "./TestimonialCard.scss";
import Image from "next/image";
import Ratings from "../Shared/Ratings/Ratings";
import { ReactSVG } from "react-svg";

interface TestimonialCardProps {
  name: string;
  image?: string;
  rate: number;
  testimonial: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  name,
  image,
  rate,
  testimonial,
}) => {
  const fallbackLabel = name.trim().charAt(0).toUpperCase() || "?";

  return (
    <div className="testimonial-card-wrapper">
      <div className="testimonial-header-wrapper">
        <div className="left">
          {image ? (
            <Image src={image} alt={name} width={64} height={64} />
          ) : (
            <div className="avatar-fallback text-medium-24 weight-600 blue-500">
              {fallbackLabel}
            </div>
          )}
          <div className="middle">
            <p className="text-medium-24 weight-600 black">{name}</p>
            <Ratings rate={rate} />
          </div>
        </div>


        <div className="full-rate">
          <ReactSVG src={"/assets/blue-star-ic.svg"} width={22} height={22} />
          <p className="text-xsmall-18 blue-500 weight-600">{rate}</p>
        </div>
      </div>

      <p className="text-16 weight-500 grey-600">{testimonial}</p>
    </div>
  );
};

export default TestimonialCard;
